import { __rest } from "tslib";
import * as React from 'react';
import { ClassNames } from '../../utils/classNames';
/** Render an icon using one of the supported icon sets */

export var Icon = function Icon(_a) {
  var className = _a.className,
      iconSet = _a.iconSet,
      icon = _a.icon,
      onClick = _a.onClick,
      nativeProps = __rest(_a, ["className", "iconSet", "icon", "onClick"]);

  return React.createElement("div", Object.assign({
    "aria-hidden": true
  }, nativeProps, {
    "data-icon-set": iconSet,
    "data-i": icon,
    className: ClassNames.concat('arm-icon', className),
    "data-clickable": !!onClick,
    onClick: onClick
  }));
};
/** Renders an Icomoon icon - requires the consuming application to have manually added the Icomoon font file */

export var IcomoonIcon = function IcomoonIcon(_a) {
  var icon = _a.icon,
      props = __rest(_a, ["icon"]);

  return React.createElement(Icon, Object.assign({}, props, {
    iconSet: "Icomoon",
    icon: icon
  }));
};
/** Renders an LinearIcon icon - requires the consuming application to have manually added the LinearIcon font file */

export var LinearIcon = function LinearIcon(_a) {
  var icon = _a.icon,
      props = __rest(_a, ["icon"]);

  return React.createElement(Icon, Object.assign({}, props, {
    iconSet: "LinearIcons",
    icon: icon
  }));
};